// import Search from "./ModelSearch";
import { Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import { translate } from "utils";
import { FormRequest, FormRequestQueryParams } from "./type";
import { uuid } from "short-uuid";

interface Props {
	query: FormRequestQueryParams;
	setQuery?: Function;
	total?: number;
	getData: (query: FormRequestQueryParams) => void;
	dataSource: FormRequest[];
	loading: boolean;
	columns: ColumnsType<FormRequest>;
}
export default function FormRequestTable({
	query,
	total,
	getData,
	dataSource,
	loading,
	columns,
}: Props) {
	const handleChangePage = (page: number) => {
		getData({ ...query, skip: page - 1 });
	};
	const handlePageSizeChange = (_: number, size: number) => {
		setTimeout(() => {
			getData({ ...query, skip: 0, take: size });
		}, 0);
	};

	return (
		<Table
			dataSource={dataSource}
			bordered
			scroll={{ x: 800 }}
			columns={columns}
			rowKey={record => record._id || uuid()}
			loading={loading}
			pagination={{
				pageSizeOptions: ["5", "10", "20", "50"],
				total: total,
				current: query.skip + 1,
				pageSize: query.take,
				showSizeChanger: true,
				showTotal: total =>
					`${translate("Total")} ${total} ${translate("results")}`,
				onChange: handleChangePage,
				onShowSizeChange: handlePageSizeChange,
			}}
			locale={{
				emptyText: <span className="text-gray-8">{translate("No data")}</span>,
			}}
		/>
	);
}
